import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KPIDashboardService, Region } from '~lmo/kpidashboard/kpidashboard.service';
import { trackById } from '~utilities/trackById';

@Component({
  selector: 'sa-region-selector',
  styleUrls: ['./region-selector.component.scss'],
  templateUrl: './region-selector.component.html',
})
export class RegionSelectorComponent implements OnInit {
  public regions: Region[] = [];
  public selectedRegionId: number | string | null = null;
  public isLoading = true;

  constructor(private kpiDashboardService: KPIDashboardService, private activatedRoute: ActivatedRoute) {}

  public readonly trackById = trackById;

  public ngOnInit(): void {
    const localRegionID = this.kpiDashboardService.getLocalStorage('region_id');
    this.kpiDashboardService.setRegionID(localRegionID);

    this.activatedRoute.queryParams.subscribe((params) => {
      const regionId = params['region_id'] ? +params['region_id'] : localRegionID;
      this.selectedRegionId = regionId !== null ? regionId : 'all';
    });

    this.kpiDashboardService.getRegions$().subscribe({
      complete: () => {
        this.isLoading = false;
      },
      error: () => {},
      next: (data) => {
        this.regions = data;

        if (!this.selectedRegionId || !this.regions.some((region) => region.id === this.selectedRegionId)) {
          this.selectedRegionId = 'all';
        }
      },
    });
  }

  public onSelectionChange(selectedId: number | string): void {
    this.selectedRegionId = selectedId;
    this.kpiDashboardService.setRegionID(selectedId === 'all' ? null : (selectedId as number));
    this.kpiDashboardService.setLocalStorage('region_id', this.selectedRegionId);
  }
}
